module.exports = __webpack_public_path__ + "img/8985496.jpg";